export default __webpack_public_path__ + "static/media/webApp.95b901e3.svg";